import { Heading } from "@root/clientFrontend/components/Heading";
import { Label } from "@root/shared/components/Label";
import { type ComponentProps, type FC } from "react";
import { TextArea } from "@root/shared/components/TextArea";
import { Checkbox } from "@root/shared/components/Checkbox";
import { InformationText } from "@root/shared/components/InformationText";
import { useFormContext } from "react-hook-form";
import * as styles from "./styles.css";

type Props = {
  questionTitle: ComponentProps<typeof Heading>["children"];
  titleTag: ComponentProps<typeof Heading>["tag"];
  checkboxesProps?: {
    name: string;
    questions: {
      text: string;
      checkboxProps: ComponentProps<typeof Checkbox>;
    }[];
  };
  // TextAreaにもnameはあるが必須項目ではなく、今回は必須にしたいため敢えて分けている
  textAreaProps: ComponentProps<typeof TextArea> & { name: string };
  isOtherChecked?: boolean;
};

export const HeadingAndCheckboxAndTextArea: FC<Props> = ({
  questionTitle,
  titleTag = "p",
  checkboxesProps,
  textAreaProps,
  isOtherChecked,
}) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();
  const checkboxError = checkboxesProps ? errors[checkboxesProps.name] : "";
  const textAreaError = errors[textAreaProps.name];
  return (
    <>
      <Heading tag={titleTag} size="small" label={<Label theme="red">必須</Label>}>
        {questionTitle}
      </Heading>
      {checkboxesProps && (
        <>
          {checkboxError && (
            <div className={styles.errorTextOuter}>
              <InformationText text={checkboxError.message} isAlert />
            </div>
          )}
          {checkboxesProps.questions.length > 0 && (
            <div className={styles.checkboxQuestions}>
              {checkboxesProps.questions.map(({ text, checkboxProps }) => {
                const id = `checkbox-${checkboxesProps.name}-${checkboxProps.value}`;
                return (
                  <label key={text} htmlFor={id} className={styles.label}>
                    <Checkbox
                      {...checkboxProps}
                      id={id}
                      {...register(checkboxesProps.name)}
                      hasError={!!checkboxError}
                    />
                    <span className={styles.checkboxText}>{text}</span>
                  </label>
                );
              })}
            </div>
          )}
        </>
      )}
      <div className={styles.textareaOuter}>
        <TextArea
          size="large"
          {...textAreaProps}
          {...register(textAreaProps.name || "")}
          hasError={!!textAreaError}
          disabled={checkboxesProps && !isOtherChecked} // チェックボックスの選択肢があるかつ「その他」を選択していない場合はdisabled
        />
      </div>
      {textAreaError && (
        <div className={styles.errorTextOuter}>
          <InformationText text={textAreaError.message} isAlert />
        </div>
      )}
    </>
  );
};
